import {action, makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import { BillingPeriodService } from "../../../service/BillingPeriodService";

class BillBillingPeriodStore {

    public billingPeriodId: string;
    public isModalOpen: boolean;
    public loading: boolean;
    public commonStore: CommonStore;

    constructor(commonStore: CommonStore, billingPeriodId: string) {
        this.billingPeriodId = billingPeriodId;
        this.isModalOpen = false;
        this.loading = false;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }

    @action
    public async openModal() {
        this.loading = true;
        this.isModalOpen = true;
        this.loading = false;
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
    }

    @action
    public async bill(): Promise<boolean> {
        this.loading = true;
        const response = await BillingPeriodService.bill(this.billingPeriodId);
        this.commonStore.processErrors(response);
        this.loading = false;
        return response.success;
    }
}

export default BillBillingPeriodStore;